module.exports = __webpack_public_path__ + "img/opta.eb4c5e7e.png";